<form [formGroup]="customerForm" (ngSubmit)="customerFormSubmit()" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 ">
  <div class="px-4 py-6 sm:p-8">
    <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
      

      <div class="sm:col-span-3">
        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">First Name</label>
        <div class="mt-2">
          <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-accent ">
            
            <input formControlName="firstName" type="text"  class="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="Customer first name">
          </div>
        </div>
      </div>

      <div class="sm:col-span-3">
        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Last Name</label>
        <div class="mt-2">
          <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-accent ">
            
            <input formControlName="lastName"  type="text"  class="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="Customer last name">
          </div>
        </div>
      </div>

      <div class="sm:col-span-3">
        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Email Address</label>
        <div class="mt-2">
          <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-accent ">
            
            <input formControlName="email"  type="email"  class="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="customer@email.com">
          </div>
        </div>
      </div>

      <div class="sm:col-span-3">
        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Telephone</label>
        <div class="mt-2">
          <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-accent ">
            
            <input formControlName="tel"  type="text"  class="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="077123456789">
          </div>
        </div>
      </div>

      <div class="sm:col-span-6">
        <div>
          <label for="comment" class="block text-sm font-medium leading-6 text-gray-900">Notes</label>
          <div class="mt-2">
            <textarea formControlName="notes"  rows="4" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex items-center justify-between gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
    
    <button type="button" (click)="changeCustomerClicked()"  class="rounded-md  px-3 py-2 text-xs font-semibold text-gray-400 hover:text-accent-light ">Change customer</button>
    <button 
      type="submit" 
      [disabled]="!customerForm.dirty || !customerForm.valid" 
      class="rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-accent-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
      Update Customer Details
    </button>
  </div>
</form>

